 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		38: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		38: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","3":"component---src-pages-404-jsx","4":"component---src-pages-about-faqs-jsx","5":"component---src-pages-about-history-jsx","6":"component---src-pages-about-index-jsx","7":"component---src-pages-about-mission-jsx","8":"component---src-pages-about-practices-jsx","9":"component---src-pages-about-yerushalmi-jsx","10":"component---src-pages-contact-jsx","11":"component---src-pages-donate-jsx","12":"component---src-pages-haftara-study-index-jsx","13":"component---src-pages-index-jsx","14":"component---src-pages-mishna-study-index-jsx","15":"component---src-pages-mishna-study-parts-jsx","16":"component---src-pages-moadim-study-index-jsx","17":"component---src-pages-parasha-plus-study-index-jsx","18":"component---src-pages-parasha-plus-study-parts-jsx","19":"component---src-pages-parasha-study-index-jsx","20":"component---src-pages-parasha-study-parts-jsx","21":"component---src-pages-signup-jsx","22":"component---src-pages-talmud-study-index-jsx","23":"component---src-pages-talmud-study-parts-jsx","24":"component---src-pages-tanach-study-index-jsx","25":"component---src-pages-tanach-study-parts-jsx","26":"component---src-pages-whatsapp-jsx","27":"component---src-templates-mishna-study-masechtot-masechtot-jsx","28":"component---src-templates-mishna-study-perakim-perakim-jsx","29":"component---src-templates-parasha-study-perakim-perakim-jsx","30":"component---src-templates-parasha-study-plus-sefarim-sefarim-jsx","31":"component---src-templates-parasha-study-sefarim-sefarim-jsx","32":"component---src-templates-talmud-study-dapim-dapim-jsx","33":"component---src-templates-talmud-study-masechtot-masechtot-jsx","34":"component---src-templates-tanach-study-perakim-perakim-jsx","35":"component---src-templates-tanach-study-sefarim-sefarim-jsx","36":"component---src-templates-teachers-all-teachers-jsx","37":"component---src-templates-teachers-teacher-jsx"}[chunkId]||chunkId) + "-" + {"0":"d25f4c068efdc0720a41","3":"02c16fc6f5f9a0a41a28","4":"5164d8a831e0dd853cad","5":"ae9cb5949aeacab27e11","6":"01d351785c053bffb13e","7":"8a932873aae76a380861","8":"86d6d52fbbcb5afef9d1","9":"246799d4561189e3190a","10":"c86f1b5f39ee25457949","11":"490f20dd0f7e3f1bf1fe","12":"f84e423c1d96c05d7055","13":"7e92c5d7fa7e66bb0863","14":"a3f96193063a32c16116","15":"9dfc34bf4bcfbae2b121","16":"696f573bff0de81107ed","17":"132895f7cdb4e6ec3f6e","18":"3884255cdd9b27841ae8","19":"edde472bfbb40b10d68a","20":"2d3573b9d8636bbbd6d0","21":"75820b65f82d02ec6f21","22":"e926f5badde32b1bb2c3","23":"beae6521bfabd7f09a48","24":"a91b862f333d0b095c39","25":"3c39fbb9fb7fb0e3fa68","26":"b2e67a25cd6242d02de1","27":"a2eb936fcbe98eb26528","28":"78b1a7983395e989712d","29":"009f224974b9983d0ae7","30":"e1fbd7aa529ddf18ea15","31":"2ef75dfc537d726a2f0b","32":"5c0c132f93ea5a58965c","33":"82968c58121dd89c81af","34":"b67dc0eae6977ab9355b","35":"fd1cd9f092bf442bdbde","36":"b74f4edac21b0f2f7c7a","37":"99f77c3abdafc10d83cd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","3":"component---src-pages-404-jsx","4":"component---src-pages-about-faqs-jsx","5":"component---src-pages-about-history-jsx","6":"component---src-pages-about-index-jsx","7":"component---src-pages-about-mission-jsx","8":"component---src-pages-about-practices-jsx","9":"component---src-pages-about-yerushalmi-jsx","10":"component---src-pages-contact-jsx","11":"component---src-pages-donate-jsx","12":"component---src-pages-haftara-study-index-jsx","13":"component---src-pages-index-jsx","14":"component---src-pages-mishna-study-index-jsx","15":"component---src-pages-mishna-study-parts-jsx","16":"component---src-pages-moadim-study-index-jsx","17":"component---src-pages-parasha-plus-study-index-jsx","18":"component---src-pages-parasha-plus-study-parts-jsx","19":"component---src-pages-parasha-study-index-jsx","20":"component---src-pages-parasha-study-parts-jsx","21":"component---src-pages-signup-jsx","22":"component---src-pages-talmud-study-index-jsx","23":"component---src-pages-talmud-study-parts-jsx","24":"component---src-pages-tanach-study-index-jsx","25":"component---src-pages-tanach-study-parts-jsx","26":"component---src-pages-whatsapp-jsx","27":"component---src-templates-mishna-study-masechtot-masechtot-jsx","28":"component---src-templates-mishna-study-perakim-perakim-jsx","29":"component---src-templates-parasha-study-perakim-perakim-jsx","30":"component---src-templates-parasha-study-plus-sefarim-sefarim-jsx","31":"component---src-templates-parasha-study-sefarim-sefarim-jsx","32":"component---src-templates-talmud-study-dapim-dapim-jsx","33":"component---src-templates-talmud-study-masechtot-masechtot-jsx","34":"component---src-templates-tanach-study-perakim-perakim-jsx","35":"component---src-templates-tanach-study-sefarim-sefarim-jsx","36":"component---src-templates-teachers-all-teachers-jsx","37":"component---src-templates-teachers-teacher-jsx"}[chunkId]||chunkId) + "." + {"0":"8a3707591bd7192065f4","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
